import { inject } from "@angular/core";
import { signalStore, withMethods, patchState, withHooks, type } from "@ngrx/signals";
import { withEntities, setEntity, setAllEntities } from "@ngrx/signals/entities";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { BackOfficeOfferViewModel } from "@playcharge/common/models/backend/offers/backoffice/backoffice-offer-view-model";
import { OfferType } from "@playcharge/common/models/backend/offers/offer-type";
import { pipe, switchMap, tap } from "rxjs";
import { ApiOffersService } from "../../services/api-offers.service";
import { withRequestStatus, setFulfilled } from "../extensions/request-status.feature";
import { withOffersMethods } from "../extensions/offers-methods.feature";

export type AppsStore = InstanceType<typeof AppsStore>;

export const AppsStore = signalStore(
    { providedIn: "root", protectedState: false },
    withEntities<BackOfficeOfferViewModel>(),
    withEntities({ entity: type<BackOfficeOfferViewModel>(), collection: "archived" }),
    withRequestStatus(),
    withOffersMethods(),
    withMethods((store, apiOffersService = inject(ApiOffersService)) => ({
        loadOffers: rxMethod<void>(
            pipe(
                switchMap(() => {
                    return apiOffersService.getAll(OfferType.App, false).pipe(
                        tap((offers) => {
                            patchState(store, setAllEntities(offers));
                            patchState(store, setFulfilled());
                        }),
                    );
                }),
            ),
        ),
        loadArchived: rxMethod<void>(
            pipe(
                switchMap(() => {
                    return apiOffersService.getAll(OfferType.App, true).pipe(
                        tap((offers) => {
                            patchState(store, setAllEntities(offers, { collection: "archived" }));
                        }),
                    );
                }),
            ),
        ),
    })),
    withHooks({
        onInit({ loadOffers, loadArchived }) {
            loadOffers();
            loadArchived();
        },
    }),
);
